<template>
  <div>
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <el-form ref="ForgetPasswordForm" :rules="rule" label-width="80px"
             :model="forgetPasswordForm">
      <div style="text-align: center;padding-top: 300px;">
        <div style="margin: auto;position: relative;padding-bottom: 60px;width: 650px;">
          <el-form-item label="ID" prop="eventId">
            <el-input v-model="forgetPasswordForm.eventId" disabled></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="forgetPasswordForm.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPwd">
            <el-input v-model="confirmPwd"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doChangePasswordByForget">提交</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";
import HeaderMain from "@/views/share/HeaderMain";

export default {
  name: "ForgetPassword",
  components: {
    HeaderMain
  },
  data() {
    const validateEventId = (rule, value, callback) => {
      if (value !== this.backupEventId) {
        callback(new Error('你懂的╰（‵□′）╯'))
      }
      callback();
    }
    const validateConfirmPwd = (rule, value, callback) => {
      if (this.confirmPwd === '') {
        callback(new Error('请再次输入密码'))
      } else {
        if (this.confirmPwd !== this.forgetPasswordForm.newPassword) {
          callback(new Error('两次输入的密码不同'));
        }
        callback();
      }
    }
    return {
      backupEventId: '',
      forgetPasswordForm: {
        eventId: '',
        newPassword: ''
      },
      confirmPwd: '',
      rule: {
        eventId: [
          {validator: validateEventId, trigger: 'blur'}
        ],
        newPassword: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 256, message: '请输入正确长度的密码[8-256]', trigger: 'blur'}
        ],
        confirmPwd: [
          {validator: validateConfirmPwd, trigger: 'blur'}
        ]
      }
    }
  },
  beforeCreate() {
    AxiosBase.axiosGet("/user/forget-verify", {
      params: {
        forgetPasswordId: this.$route.query.forgetPasswordId
      }
    }).then(response => {
      if (response !== 0) {
        this.forgetPasswordForm.eventId = response.data.id;
        this.backupEventId = response.data.id;
      } else {
        this.$router.push("404")
      }
    })
  },
  mounted() {
    document.title = "斑斓魔法CG-忘记密码";
  },
  methods: {
    doChangePasswordByForget() {
      this.$refs['ForgetPasswordForm'].validate((valid) => {
        if (valid) {
          AxiosBase.axiosPost("/user/forget-change-password", this.forgetPasswordForm).then(response => {
            if (response !== 0) {
              Message({
                showClose: true,
                message: '密码修改成功',
                type: 'success'
              });
              this.$router.push("login");
            }
          })
        }
      });
    }
  }
}
</script>

